import { sentryReport } from '@modules/shared/utils';

export const sendFeedback = sentryReport.feedback;
